/** Client types whose matching-domain users are marked Paid = paid on sign-in and sign-up. */
export const AUTO_PAID_CLIENT_TYPES = ["MA", "MP", "CA", "CP"];

export function clientTypeGrantsPaidAccess(clientType) {
  return AUTO_PAID_CLIENT_TYPES.includes(String(clientType || "").trim().toUpperCase());
}

export function normalizeCompanyDomain(value) {
  return String(value || "")
    .toLowerCase()
    .trim()
    .replace(/^(https?:\/\/)?/, "")
    .replace(/^www\./, "")
    .split("/")[0];
}

export function emailDomainMatchesCompany(emailDomain, companyDomain) {
  const email = normalizeCompanyDomain(emailDomain);
  const company = normalizeCompanyDomain(companyDomain);
  if (!email || !company) return false;
  return email === company || email.endsWith(`.${company}`);
}

export function companyGrantsPaidAccess(companyFields, emailDomain) {
  if (!clientTypeGrantsPaidAccess(companyFields?.ClientType)) return false;
  return emailDomainMatchesCompany(emailDomain, companyFields?.Domain);
}

export function userNeedsAutoPaid(paidValue) {
  const current = String(paidValue || "").trim().toLowerCase();
  return !current || current === "unpaid";
}
